<template>
  <div>
    <Header />
    <div id="wrapper">
      <div id="bf-contents">
        <slot />
      </div>
      <Footer />
    </div>
  </div>
</template>

<script>
import Header from "@/js/components/Header.vue"
import Footer from "@/js/components/Footer.vue"

export default {
  components: {
    Footer,
    Header
  }
}
</script>